"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContainerStyle = void 0;
const useContainerStyle = ({ centered, gap, margin, padding, direction }) => {
    const centeredProps = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        flexDirection: direction || 'row',
    };
    const sizes = {
        xs: '0.5rem',
        sm: '1rem',
        md: '2rem',
        lg: '3rem',
        xl: '4rem',
        xxl: '5rem',
    };
    const mainContainerStyles = Object.assign({ padding: `${padding ? sizes[padding] || padding : '0'}`, margin: `${margin ? sizes[margin] || margin : '0'}`, gap: `${gap ? sizes[gap] || gap : '0'}` }, (centered && centeredProps));
    return {
        mainContainerStyles,
    };
};
exports.useContainerStyle = useContainerStyle;
